import './Service.css';

function Service() {
    return (
        <div className="service_area pt_80 pb_80" id='Services'>
            <div className="container relative">
                <div className="service_contant heading text_align_center">
                    <h2><span>M</span> y Services</h2>
                    <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit.Explicabo ipsa ipsam quam a quae amet!</p><br />
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Harum,error?</p>
                </div>
                <div className="row">
                    <div className="col_3">
                    <div class="circle1 circle"></div>
                    <div class="circle2 circle"></div>
                        <div className="service_box pointer">
                            <div className="icon">
                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2" y2="20"></line></svg>
                            </div>
                            <div className="service_text">
                                <h2>Business tratagy</h2>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto nihil dolor ipsa velit, placeat quibusdam aliquid ducimus officia quae quaerat?</p>
                            </div>
                        </div>
                    </div>
                    <div className="col_3">
                        <div className="service_box pointer">
                            <div className="icon">
                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
                            </div>
                            <div className="service_text">
                                <h2>Webste Development</h2>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto nihil dolor ipsa velit, placeat quibusdam aliquid ducimus officia quae quaerat?</p>
                            </div>
                        </div>
                    </div>
                    <div className="col_3">
                        <div className="service_box pointer">
                            <div className="icon">
                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                            </div>
                            <div className="service_text">
                                <h2>marketing & reporting</h2>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto nihil dolor ipsa velit, placeat quibusdam aliquid ducimus officia quae quaerat?</p>
                            </div>
                        </div>
                    </div>
                    <div className="col_3">
                        <div className="service_box pointer">
                            <div className="icon">
                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                            </div>
                            <div className="service_text">
                                <h2>apps development</h2>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto nihil dolor ipsa velit, placeat quibusdam aliquid ducimus officia quae quaerat?</p>
                            </div>
                        </div>
                    </div>
                    <div className="col_3">
                        <div className="service_box pointer">
                            <div className="icon">
                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                            </div>
                            <div className="service_text">
                                <h2>Business tratagy</h2>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto nihil dolor ipsa velit, placeat quibusdam aliquid ducimus officia quae quaerat?</p>
                            </div>
                        </div>
                    </div>
                    <div className="col_3">
                        <div className="service_box pointer">
                            <div className="icon">
                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                            </div>
                            <div className="service_text">
                                <h2>creative design</h2>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto nihil dolor ipsa velit, placeat quibusdam aliquid ducimus officia quae quaerat?</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Service;